module.exports = __webpack_public_path__ + "img/apple-app-store-btn-EN.53a0947c.svg";